import OrderDetailsPopup, { OrderDetailsPopupProps } from './OrderDetailsPopup'

export default OrderDetailsPopup
export type { OrderDetailsPopupProps }
